import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import IdeaShowPage from '@buyside/components/presentation/IdeaShowPage/ideaShowPage';

const OpenIdeaShowPageRoot: FC<{ ideaId: string }> = ({ ideaId }) => {
  if (!ideaId) return;

  return (
    <ErrorBoundary pageName="this idea">
      <IdeaShowPage ideaId={ideaId} isPublic />
    </ErrorBoundary>
  );
};

export default OpenIdeaShowPageRoot;
